import { motion } from "framer-motion";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";

const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-2 block font-mono text-xs uppercase tracking-widest text-[#a3b1aa]">{label}</span>
    {children}
  </label>
);

export const ContactStep = ({ form, set, onSubmit, sending }) => (
  <motion.form initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }} onSubmit={onSubmit} data-testid="coaching-contact-form" className="space-y-5">
    <h2 className="font-display text-3xl font-900 uppercase leading-[0.95] md:text-5xl">Dove posso ricontattarti?</h2>
    <div className="grid gap-5 md:grid-cols-2">
      <Field label="Nome e cognome"><Input data-testid="coaching-name-input" required minLength={2} maxLength={80} value={form.name} onChange={(e) => set("name", e.target.value)} className="h-12" /></Field>
      <Field label="Telefono"><Input data-testid="coaching-phone-input" required type="tel" minLength={6} maxLength={25} pattern="[0-9+()\s.-]+" value={form.phone} onChange={(e) => set("phone", e.target.value)} className="h-12" /></Field>
    </div>
    <Field label="Email"><Input data-testid="coaching-email-input" required type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className="h-12" /></Field>
    <Field label="Vuoi aggiungere qualcosa? (facoltativo)"><Textarea data-testid="coaching-note-input" maxLength={1000} rows={4} value={form.note} onChange={(e) => set("note", e.target.value)} placeholder="Esperienze passate, infortuni, orari..." /></Field>
    <label className="flex items-start gap-3 text-sm text-[#a3b1aa]">
      <Checkbox data-testid="coaching-consent-checkbox" checked={form.consent} onCheckedChange={(v) => set("consent", v === true)} className="mt-0.5" />
      Acconsento al trattamento dei miei dati personali, compresi quelli relativi alla salute indicati nell'anamnesi, da parte di Hybrid Health Lab per valutare il percorso di training online ed essere ricontattato/a.
    </label>
    <button data-testid="coaching-submit-btn" disabled={sending || !form.consent}
      className="w-full bg-[#98bfa2] px-7 py-4 font-display text-lg font-800 uppercase text-[#050807] transition-colors hover:bg-[#c4dcca] disabled:opacity-50 md:w-auto">
      {sending ? "Invio in corso…" : "Invia il check-up"}
    </button>
  </motion.form>
);
